import Vue from 'vue'
import Vuex from 'vuex'
import * as types from "./types"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
		user: localStorage.user || null,
		token: localStorage.token || null,
		hallId:localStorage.hallId || null, // 展厅Id
		hotId:localStorage.hotId || null,
		types,
		wxUser: localStorage.wxUser || null,
  },
  mutations: {
		SET_User(state, data) {
			state.user = JSON.stringify(data);
			localStorage.setItem("user", JSON.stringify(data));
			console.log(localStorage.user)
		},
		updataHallId(state, payload) {
			localStorage.hallId = payload;
			state.hallId = payload
		},
		updataHotId(state,payload){
			localStorage.hotId = payload;
			state.hotId = payload
		},
		updataWxUser(state,payload) {
			localStorage.wxUser = payload;
			state.wxUser = payload
		}
  },
  actions: {
  },
  modules: {
  }
})
